import React, { useEffect, useState } from "react";
import axios from "axios";
import { inputStyles } from "./styles/inputStyles";
import { useNetwork } from "../../NetworkProvider/index.jsx";
import { TextField } from "@mui/material";
// import ClearInputButton from "../../Buttons/ClearInputButton";
const LocationSearch = ({ eventData, setEventData, setHasChanges }) => {
    const { isOnline } = useNetwork();
    const resetLocation = {
        lat: null,
        long: null,
        address_1: null,
        zip_code: null,
        city: null,
        country: null,
    };
    const [query, setQuery] = useState(eventData.address_1 || "");
    const [selectPlace, setSelectPlace] = useState(eventData.address_1 || null);
    const [filteredPlaces, setFilteredPlaces] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!eventData.client_id) {
            setQuery("");
        }
    }, [eventData.client_id]);

    // fetch data with proper URL encoding
    const findPlace = async () => {
        if (!isOnline || query.length < 3) return;

        setIsLoading(true);
        setError(null);

        try {
            // Properly encode the query parameter
            const encodedQuery = encodeURIComponent(query);
            const apiUrl = `https://data.geopf.fr/geocodage/completion/?text=${encodedQuery}&terr=METROPOLE&maximumResponses=10`;

            const response = await axios.get(apiUrl);
            setFilteredPlaces(response.data.results || []);
        } catch (err) {
            console.error("Error fetching location data:", err);
            setError(
                "Impossible de récupérer les adresses. Veuillez réessayer."
            );
            setFilteredPlaces([]);
        } finally {
            setIsLoading(false);
        }
    };

    // select a place
    const handleSelect = (place) => {
        setEventData((prev) => ({
            ...prev,
            lat: place.y,
            long: place.x,
            address_1: place.fulltext,
            zip_code: place.zipcode,
            city: place.city,
        }));
        setSelectPlace(place);
        setQuery(place.fulltext);
        setFilteredPlaces([]);
        setShowSuggestions(false);
    };

    useEffect(() => {
        if (query.length < 3) {
            if (query != eventData.address_1) {
                setHasChanges(true);
            }
            setFilteredPlaces([]);
            setShowSuggestions(false);
            if (query.length === 0) {
                setSelectPlace(null);
                setEventData((prev) => ({ ...prev, ...resetLocation }));
            }
        } else {
            setEventData((prev) => ({ ...prev, address_1: query }));
            if (isOnline) {
                setShowSuggestions(true);
                findPlace();
            }
        }
    }, [query, isOnline]);

    useEffect(() => {
        if (selectPlace) {
            setFilteredPlaces([]);
            setShowSuggestions(false);
        }
    }, [selectPlace]);

    // const resetAddress = () => {
    //     setSelectPlace(null);
    //     setFilteredPlaces([]);
    //     setQuery("");
    // };

    const handleChange = (e) => {
        setQuery(e.target.value);
        setHasChanges(true);
    };

    return (
        <div className="relative">
            <TextField
                variant="filled"
                type="text"
                value={query}
                name="address_1"
                onChange={(e) => handleChange(e)}
                label="Rajouter une adresse"
                fullWidth
                onFocus={() => {
                    if (query.length >= 3) setShowSuggestions(true);
                }}
                onBlur={() => {
                    // Delay hiding suggestions to allow for clicks
                    setTimeout(() => setShowSuggestions(false), 200);
                }}
                sx={inputStyles}
            />

            {isLoading && (
                <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg p-3 z-10">
                    Chargement des adresses...
                </div>
            )}

            {error && (
                <div className="absolute top-full w-full bg-white border border-red-300 rounded-lg shadow-lg p-3 text-red-500 z-10">
                    {error}
                </div>
            )}

            {/* {query !== "" && <ClearInputButton action={resetAddress} />} */}
            {showSuggestions && filteredPlaces.length > 0 && (
                <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg max-h-60 overflow-y-auto no-scrollbar z-10 text-left">
                    {filteredPlaces.map((place) => (
                        <div
                            key={place.id}
                            onMouseDown={(e) => {
                                e.preventDefault(); // Prevent any unwanted behavior
                                handleSelect(place);
                            }}
                            className="cursor-pointer px-3 py-2 hover:bg-gray-100"
                        >
                            <div className="flex flex-row items-center h-full">
                                {place.fulltext}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {showSuggestions &&
                query.length >= 3 &&
                filteredPlaces.length === 0 &&
                !isLoading &&
                !error && (
                    <div className="absolute top-full w-full bg-white border border-slate-300 rounded-lg shadow-lg p-3 z-10">
                        Aucune adresse trouvée
                    </div>
                )}
        </div>
    );
};

export default LocationSearch;
